import React from 'react'
import { useWindowResizeSensor } from 'oio-react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import MainMenu from 'src/apps/AdminWorkspace/apps/MainMenu'
import ContentViewport from 'src/components/Settings/ContentViewport'
import ProtoColumnB from 'src/components/Settings/ProtoColumnB'
import ProtoColumnC from 'src/components/Settings/ProtoColumnC'
import NotFound from 'src/pages/NotFound'
import DesignColors from './Colors'
import DesignHome from './Home'
import DesignTypography from './Typography'

const AdminWorkspaceDesign = () => {
   const match = useRouteMatch()
   const { currentBreakpoint } = useWindowResizeSensor()
   const currentModeHasThreeColumns = currentBreakpoint > 'd'

   return (
      <ContentViewport>
         <ProtoColumnB>
            <DesignHome />
         </ProtoColumnB>
         <Switch>
            {currentModeHasThreeColumns && (
               <Redirect
                  exact
                  from={match.url}
                  to={`${match.url}/main-menu`}
               />
            )}
            <Route
               path={[
                  `${match.url}/colors`,
                  `${match.url}/main-menu`,
                  `${match.url}/typography`
               ]}>
               <ProtoColumnC>
                  <Switch>
                     <Route path={`${match.url}/main-menu`}>
                        <MainMenu
                           returnLinkName="Design Settings"
                           returnLinkTo={match.url}
                        />
                     </Route>
                     <Route
                        path={`${match.url}/colors`}
                        component={DesignColors}
                     />
                     <Route
                        path={`${match.url}/typography`}
                        component={DesignTypography}
                     />
                  </Switch>
               </ProtoColumnC>
            </Route>
            <Route
               path={`${match.url}/:invalid`}
               component={NotFound}
            />
         </Switch>
      </ContentViewport>
   )
}

export default AdminWorkspaceDesign
